import generateAsyncRouteComponent from '../generateAsyncRouteComponent';

export default {
  path: 'reviews',
  component: generateAsyncRouteComponent({
    loader: () => import('./containers/ReviewsPageContainer.jsx'),
  }),
};
